import {HotKeys} from './mappings';
import {executeHotKeySearch} from '../Searches/actions/searchesList';
import {formsStore} from '../Form/stores/FormsStore';
import {renderGenerator, renderGeneratorNewState} from '../Searches/renderGenerator';

export function executeKey(key, parameter?) {
    switch (key) {
        case HotKeys.ExecuteQuery:
            executeHotKeySearch(parameter);
            break;
        case HotKeys.OpenGenerator:
            if (formsStore.searchesStore.formSelected) {
                renderGenerator('searchesGenerator');
            } else {
                renderGeneratorNewState();
            }
            break;
        default:
            break;
    }
}
